import axios from "axios";
import { BASE_URL } from "../constants";
import { toast } from "react-toastify";

const requestHandler = (request) => {
  const token = localStorage.getItem("token");
  request.headers["Authorization"] = `Bearer ${token}`;
  return request;
};

const errorHandler = (error) => {
  // if (error.response.status === 403) window.location.href = "/login";
  if (error.response && error.response.data)
    toast.error(error.response.data.message);
  else {
    if(error.message === "Network Error") 
      toast.error("Sepertinya koneksi internet Anda terputus, silakan cek.");
    else toast.error(JSON.stringify(error))
  }
  return Promise.reject({ ...error });
};

const successHandler = (response) => {
  return response;
};

// Init Axios
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add interceptors
axiosInstance.interceptors.request.use((request) => requestHandler(request));
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export default axiosInstance;